(function () {
  const protectedImageSelector = 'img:not([data-allow-image-copy])';

  function protectedImageFromEvent(event) {
    return event.target?.closest?.(protectedImageSelector);
  }

  document.addEventListener('contextmenu', function (event) {
    if (!protectedImageFromEvent(event)) return;
    event.preventDefault();
  });

  document.addEventListener('dragstart', function (event) {
    if (!protectedImageFromEvent(event)) return;
    event.preventDefault();
  });
})();
